import CrudPage from '@modules/cruds/CrudPage';
import UniqueIdSerieForm from './UniqueIdSerieForm';
import * as yup from 'yup';
import { IConfigComponent } from '@ts/ui-models';
import { generateConfigComponent } from '@modules/dataGrid/GlobalDataGrid';

const uniqueIdSerieSchema = yup.object().shape({
  name: yup.string().required(),
  prefix: yup.string().required(),
  numCaracters: yup.string().required(),
});

const UniqueIdSeriePage = () => {
  const config: IConfigComponent = generateConfigComponent('uniqueIdSerie');

  return (
    <CrudPage
      key={'uniqueIdSeriePage'}
      configComponent={config}
      form={UniqueIdSerieForm}
      validationSchema={uniqueIdSerieSchema}
    />
  );
};

export default UniqueIdSeriePage;
